import script from "./userDisplay.vue?vue&type=script&setup=true&lang=ts"
export * from "./userDisplay.vue?vue&type=script&setup=true&lang=ts"

import "./userDisplay.vue?vue&type=style&index=0&id=6653b056&lang=scss&scoped=true"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6653b056"]])

export default __exports__